import { ScreenView } from '../layouts'
import { hasRegister, hasCurrentRole } from '../libs/auth'
const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    meta: { title: '用户登录' }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home'),
    meta: { title: '同心RIS系统', auth:[hasRegister] }
  },
  {
    path: '/ris',
    component: ScreenView,
    children: [
      {
        path: 'queue',
        name: 'queue',
        component: () => import('@/views/queue'),
        meta: { title: '护士工作站', auth:[hasRegister, hasCurrentRole]}
      },
      {
        path: 'addCheck',
        name: 'addCheck',
        component: () => import('@/views/addCheck'),
        meta: { title: '检查', auth:[hasRegister]}
      },
      {
        path: 'callNum',
        name: 'callNum',
        component: () => import('@/views/callNum'),
        meta: { title: '技师工作站', auth:[hasRegister, hasCurrentRole]}
      },
      {
        path: 'historyCheck',
        name: 'historyCheck',
        component: () => import('@/views/historyCheck'),
        meta: { title: '检查订单', auth:[hasRegister, hasCurrentRole]}
      },
      {
        path: 'edit',
        name: 'edit',
        component: () => import('@/views/editReport'),
        meta: { title: '编辑报告', auth: [hasRegister, hasCurrentRole] }
      },
      {
        path: 'mark',
        name: 'mark',
        component: () => import('@/views/reportMark'),
        meta: { title: '检查痕迹', auth: [hasRegister] }
      },
      {
        path: 'editReportList',
        name: 'editReportList',
        component: () => import('@/views/editReportList'),
        meta: { title: '医生工作站', auth: [hasRegister, hasCurrentRole] }
      },
      {
        path: 'reportHistory',
        name: 'reportHistory',
        component: () => import('@/views/reportHistory'),
        meta: { title: '历史检查', auth: [hasRegister] }
      },
      {
        path: 'printReport',
        name: 'printReport',
        component: () => import('@/views/printReport'),
        meta: { title: '打印报告', auth: [hasRegister] }
      },
      {
        path: 'appointmentCheck',
        name: 'appointmentCheck',
        component: () => import('@/views/appointmentCheck'),
        meta: { title: '预约检查', auth: [hasRegister] }
      },
      {
        path: 'reception',
        name: 'reception',
        component: () => import('@/views/reception'),
        meta: { title: '接待大屏', auth:[hasRegister] }
      },
      {
        path: 'monitorStatistical',
        name: 'monitorStatistical',
        component: () => import('@/views/monitorStatistical'),
        meta: { title: '影像监控', auth:[hasRegister] }
      },
      {
        path: 'evaluate',
        name: 'evaluate',
        component: () => import('@/views/evaluate'),
        meta: { title: '评价', auth:[hasRegister] }
      },
      {
        path: 'screening',
        name: 'screening',
        component: () => import('@/views/screening'),
        meta: { title: '院内筛查', auth:[hasRegister] }
      }
    ]
  },
  {
    path: '/aiPay',
    name: 'aiPay',
    component: () => import('@/views/aiPay'),
    meta: { title: '展示支付', auth:[hasRegister] }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test'),
    meta: { title: '用户登录' }
  }
]
//非业务路由
const notBusinessRoutes = [
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/exception/404')
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/exception/403')
  }
]

export default [
  ...constantRoutes,
  ...notBusinessRoutes
]